import { z } from "zod";

/**
 * Object key of a media file in the environment's media bucket (ADR-0015):
 * `<companyCuid>/<name>`, one tenant segment then a file name without any further path.
 * This is what is persisted, never a URL: imgproxy URLs carry a signature and a host, both of
 * which change.
 */
export const MEDIA_OBJECT_KEY_PATTERN = /^([A-Za-z0-9_-]+)\/([A-Za-z0-9_-][A-Za-z0-9._-]*)$/;

export const mediaObjectKeySchema = z.string().max(512).regex(MEDIA_OBJECT_KEY_PATTERN);
